import React from 'react';
import { Dialog, DialogContent } from "@material-ui/core";
import { useState } from 'react';
import OrderSummary from '../../bnotes_order/OrderSummary';
import { useEffect } from 'react';
import { getOrderInfo } from '../../../networking/NetworkingOrders';
import { getDefaultAddress } from '../../../networking/NetworkingAddresses';


const NettingViewOrder = ({orderID, showOrder, onCloseOrderDetail}) => {
    const [objOrder, setObjOrder] = useState({});
    const [buySellSide, setBuySellSide] = useState('Buy'); 
    const companyAddress = localStorage.getItem('BNCompany Address'); 
    const [customerAddress, setCustomerAddress] = useState('');

    const loadOrderInfo = async(orderID) => {
        const responseOrder = await getOrderInfo(orderID);  
        responseOrder.CanEdit = false;
        setBuySellSide(responseOrder.BuySell);
        setObjOrder(responseOrder);

        const customerAddressResponse = await getDefaultAddress(objOrder.CustomerID);
        if(customerAddressResponse)
        {
            setCustomerAddress(`${customerAddressResponse.AddressValue}${customerAddressResponse.City ? `, ${customerAddressResponse.City}`: '' }${customerAddressResponse.CountryId ? `, ${customerAddressResponse.CountryId}`:''}`);
        }
        else
        {
            setCustomerAddress('');
        }  
    }

    useEffect(() => {
        if(orderID && orderID > 0)
        { 
            loadOrderInfo(orderID);
        }
    },[orderID]);

    

    return (
        <Dialog
                    fullWidth={true}
                    maxWidth='md'
                    open={showOrder} onClose={onCloseOrderDetail}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogContent>
                        <OrderSummary objOrder={objOrder} buyScale={2} lockedSide={buySellSide} cancelOrder={onCloseOrderDetail} companyAddress={companyAddress} customerID={objOrder.CustomerID} customerName={objOrder.Name}
                                contactID={objOrder.contactID} contactName={objOrder.ContactName} baseCurrencySymbol={'$'} customerAddress={customerAddress} view={true}
                                
                            />
                    </DialogContent>
                </Dialog>
    )
}

export default NettingViewOrder;